<section class="user-not-valid">
  <article class="user-not-valid__card" aria-labelledby="invalid-user-title">
    <svg><use href="assets/images/ok-illustrations-sprite.svg#crying-car"></use></svg>
    <div>
      <h3>Din bruger har ikke adgang til denne portal</h3>
      <p>Du har ikke de korrekte roller tilknyttet din brugerprofil.</p>
      <p>For at få adgang til Erhvervsportalen skal du logge ind med en brugerprofil, der har de korrekte roller.</p>
      <div class="user-not-valid__actions">
        <button (click)="authService.logout()" mat-flat-button color="primary" type="button" title="Log ind nu">
          <svg class="icon-24">
            <use href="assets/images/ok-icons-sprite.svg#user-s"></use>
          </svg>
          <span>Log ind nu</span>
        </button>

        <a (click)="goToPublicPortal()" mat-flat-button color="primary" title="Gå til {{ publicPortalName }}">
          Gå til {{ publicPortalName }}
        </a>
      </div>

      <p class="user-not-valid__hint">Alternativt er det måske {{ publicPortalName }} du gerne vil tilgå.</p>
    </div>
  </article>
</section>
